<template>
    <div id="asct">
      <h2>特定商法取引に基づく表記</h2>
      <p>「特定商取引に関する法律」第11条（通信販売についての広告）に基づき以下に明示いたします</p>
      <hr>
      <div class="tile is-ancestor">
        <div class="tile is-parent">
          <article class="tile is-child box">
            <p class="title">販売業者・責任者</p>
            <div class="content">
              <p>長谷川 拓也</p>
            </div>
          </article>
        </div>
        <div class="tile is-parent">
          <article class="tile is-child box">
            <p class="title">所在地</p>
            <div class="content">
              <p>〒105-0013 東京都港区浜松町2-2-15</p>
            </div>
          </article>
        </div>
        <div class="tile is-parent">
          <article class="tile is-child box">
            <p class="title">電話番号</p>
            <div class="content">
              <p>メールでご連絡いただければ開示します。</p>
            </div>
          </article>
        </div>
      </div>
      <div class="tile is-ancestor">
        <div class="tile is-parent">
          <article class="tile is-child box">
            <p class="title">販売価格</p>
            <div class="content">
              <p>月額500円</p>
            </div>
          </article>
        </div>
        <div class="tile is-parent">
          <article class="tile is-child box">
            <p class="title">支払い時期及び方法</p>
            <div class="content">
              <p>Stripe を使用したクレジットカード決済になり、登録した日と月のその日の毎月決済が行われます。</p>
            </div>
          </article>
        </div>
        <div class="tile is-parent">
          <article class="tile is-child box">
            <p class="title">役務の提供時期</p>
            <div class="content">
              <p>登録後、ただちに利用が可能です。</p>
            </div>
          </article>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'Asct'
}
</script>

<style scoped>
  .title {
    font-size: 1.3rem;
    color: #59637F;
  }
  .content {
    font-size: 1rem;
    color: #59637F;
  }
</style>



// WEBPACK FOOTER //
// src/components/Asct.vue